import { lazy } from 'react';
import { CRoutes } from 'src/routes';

const commonParam = ':permanenturl';

/** import pages */
const OrganizationSetupHomePage = lazy(() => import('src/pages/Organization/SetupHome'));
const OrganizationSetupBasicsPage = lazy(() => import('src/pages/Organization/SetupBasics'));
const OrganizationSetupFundingPage = lazy(() => import('src/pages/Organization/SetupFunding'));
const OrganizationIntegrationsPage = lazy(() => import('src/pages/Organization/Integrations'));
const OrganizationSetupBrandingPage = lazy(() => import('src/pages/Organization/SetupBranding'));
const OrganizationProfilePage = lazy(() => import('src/pages/Organization/Profile'));
const OrganizationVerifyPage = lazy(() => import('src/pages/Organization/Verify'));
const OrganizationPricingPage = lazy(() => import('src/pages/Organization/Pricing'));

const getPath = (path: string) => `/organization/${path}`;

/** define routes */
export const ROUTE_ORGANIZATION_SETUP_INTEGRATIONS = getPath(`setupintegrations/${commonParam}`);
export const ROUTE_ORGANIZATION_SETUP_BASICS = getPath(`setupbasics/${commonParam}`);
export const ROUTE_ORGANIZATION_SETUP_HOMEPAGE = getPath(`setuphomepage/${commonParam}`);
export const ROUTE_ORGANIZATION_SETUP_FUNDING = getPath(`setupfunding/${commonParam}?`);
export const ROUTE_ORGANIZATION_VERIFY = getPath(`verify/${commonParam}?`);
export const ROUTE_ORGANIZATION_SETUP_BRANDING = getPath(`setupbranding/${commonParam}`);
export const ROUTE_ORGANIZATION_SETUP_PROFILE = getPath(`setupprofile/${commonParam}`);
export const ROUTE_ORGANIZATION_OLD_VERIFY = getPath(`verification/${commonParam}`);
export const ROUTE_ORGANIZATION_PRICING = getPath(`setuppricing/${commonParam}?`);

/** generate links */
export const getLinkRouteOrganizationSetupIntegrations = (url: string) =>
  ROUTE_ORGANIZATION_SETUP_INTEGRATIONS.replace(commonParam, url);

export const getLinkRouteOrganizationVerify = (url: string) =>
  ROUTE_ORGANIZATION_VERIFY.replace(`${commonParam}?`, url);

export const getLinkRouteOrganizationSetupBranding = (url: string) =>
  ROUTE_ORGANIZATION_SETUP_BRANDING.replace(commonParam, url);

/** export routes */
export const organizationRoutes: CRoutes = [
  {
    path: ROUTE_ORGANIZATION_SETUP_BASICS,
    Component: OrganizationSetupBasicsPage,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_SETUP_INTEGRATIONS,
    Component: OrganizationIntegrationsPage,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_SETUP_HOMEPAGE,
    Component: OrganizationSetupHomePage,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_SETUP_FUNDING,
    Component: OrganizationSetupFundingPage,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_VERIFY,
    Component: OrganizationVerifyPage,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_SETUP_BRANDING,
    Component: OrganizationSetupBrandingPage,
    showFooter: false,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_SETUP_PROFILE,
    Component: OrganizationProfilePage,
    showFooter: false,
    exact: true,
  },
  {
    path: ROUTE_ORGANIZATION_PRICING,
    Component: OrganizationPricingPage,
    exact: true,
  },
];
